import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// core components
import Navbar from "./layouts/Navbar.js";
import Footer from "./layouts/Footer.js";

import '../assets/css/Home.css'

// reactstrap components
import {
  Button
} from "reactstrap";

import { Link } from "react-router-dom";

// slick-slider
import Slider from 'react-slick';
import '../assets/css/components/Slider.css';

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

//Image import
import sliderImg1_img from '../assets/img/header_sliderImg1.jpg';
import sliderImg1_mp4 from '../assets/img/header_sliderImg1.mp4';
import slider1Logo from '../assets/img/intospace_logo_light.png';

import sliderImg2_1 from '../assets/img/header_sliderImg2_1.jpg';
import sliderImg2_2 from '../assets/img/header_sliderImg2_2.png';
import sliderImg2_3 from '../assets/img/satellite.png';

import introduceImg1 from '../assets/img/introduce_img1.png';
import introduceImg2 from '../assets/img/introduce_img2.png';
import introduceImg3 from '../assets/img/introduce_img3.png';

import businessImg1 from '../assets/img/business_img1.png';
import businessImg2 from '../assets/img/business_img2.png';
import businessImg3 from '../assets/img/business_img3.png';

import serviceImg1 from '../assets/img/service_img1.png';
import serviceImg2 from '../assets/img/service_img2.png';

import historyImg1 from '../assets/img/history_img1.jpg';
import historyImg2 from '../assets/img/history_img2.jpg';
import historyImg3 from '../assets/img/history_img3.jpg';
import historyImg4 from '../assets/img/history_img4.jpg';
import historyImg5 from '../assets/img/history_img5.jpg';
import historyImg6 from '../assets/img/history_img6.png';

import partnersImg1 from '../assets/img/partners_img1.png';
import partnersImg2 from '../assets/img/partners_img2.jpg';


// slick-slider function
function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      className= "previousButton"
      onClick={onClick}
    />
  );
}

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div
      className= "nextButton"
      onClick={onClick}
    />
  );
}

export default function Home() {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const lang = localStorage.getItem('lang') || 'ko';
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [i18n]);

  const settings = {
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    lazyLoad: true,
    //autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    cssEase: "ease-out",
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          width: '100%'  // Ensure slides use full container width
        }
      }
    ]
  }

  const settings2 = {
    centerMode: true,
    slidesToShow: 3,
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          dots: false
        }
      },
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          dots: true
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          dots: true
        }
      },
    ]
  };

  return (
    <>
    <Navbar />
    <div className="wrapper">
        <div>
          <Slider {...settings} className='mainSlider slider-wrapper fadeDivide'>
            <div className="slider-content mainSlider1"
                style={{ background: `url('${sliderImg1_img}') no-repeat center center` }}
            >
              <div className="slider1overay"></div>
              <video autoPlay muted loop>
                <source src={sliderImg1_mp4} type="video/mp4" />
              </video>
                  <div className="inner">
                    <div className="slider1Contents">
                      <h3 className="slider1Text1">{t('slider1Text1')}</h3>
                      <img className="slider1Logo" src={slider1Logo} alt="이미지" />
                      <p className="slider1Text2">New space and new life <span className="breakPointAdd"></span>with the IntoSpace</p>
                    </div>
                  </div>
            </div>
            <div className="slider-content mainSlider2">
              <div className="slider2overay"></div>
              <img className="headerBg" src={sliderImg2_1} alt="Slider"/>
                  <div className="inner">
                    <div className="slider2Contents">
                      <div className="slider2Text">
                        <h1>LONE-Smart</h1>
                        <p>LOcation Notification Emergency service <span className="breakPointAdd"><br/></span>with Smartphone</p>
                          <Link to="/LoneSmart">
                            <Button className="sliderButton">
                              {t('sliderButton')}&nbsp;&nbsp;&nbsp;<FontAwesomeIcon icon={faArrowRight} />
                            </Button>
                          </Link>
                      </div>
                      <div className="satellite">
                        <img className="satellite_bg" src={sliderImg2_2} alt="Slider"/>
                        <img className="satellite_obj" src={sliderImg2_3} alt="Slider"/>
                      </div>
                    </div>
                  </div>
            </div>
        </Slider>
      </div>
      
      <div id="IntoMessage">
        <div className="Section">
          <div className="SectionHeaderFull fadeDivide">
            <div className="SectionHeaderTxtbox">
              <div className="SectionHeaderCategory CategoryDark">Introduce</div>
              <div className="SectionHeaderTitle">{t('Greeting')}</div>
              <div className="SectionHeaderDescription" style={{fontSize:'18px'}}>
              </div>
            </div>
          </div>
          <div className="SectionContents fadeDivide">
            <div id="IntoMessage_Area">
              <div id="IntoMessage_txt1">
              {t('IntoMessage1_txt1')} <span className='breakPointAdd'> </span>
              {/* <Trans i18nKey="IntoMessage1_txt1" /> <span className='breakPointAdd'> </span> */}
              {t('IntoMessage1_txt2')}<br/><br/>
              {/* <Trans i18nKey="IntoMessage1_txt2" /> */}
              {t('IntoMessage1_txt3')}<br/>
              {t('IntoMessage1_txt4')}<br/>
              {t('IntoMessage1_txt5')} <span className='breakPoint'><br/></span>
              {t('IntoMessage1_txt6')}<br/><br/>
              {t('IntoMessage1_txt7')}<span className='breakPoint'><br/></span>
              {t('IntoMessage1_txt8')}<br/>
              {t('IntoMessage1_txt9')}<br/><br/>
              {t('IntoMessage1_txt10')}<br/>
              {t('IntoMessage1_txt11')}<br/>
              {t('IntoMessage1_txt12')}<br/>
              </div>
              <div id="IntoMessage_txt2">{t('IntoMessage2_txt1')}&nbsp;&nbsp;&nbsp;<span className='breakPointAdd'><br/></span><b>{t('IntoMessage2_txt2')}</b></div>
            </div>
          </div>
        </div>
      </div>
      
      <div id="Introduce">
        <div className="Section">
          <div className="SectionHeaderFull">
            <div className="SectionHeaderTxtbox">
              <div className="SectionHeaderCategory CategoryDark fadeDivide">Technology</div>
              <div className="SectionHeaderTitle fadeDivide">{t('SectionHeaderTitle Technology')}</div>
              <div className="SectionHeaderDescription fadeDivide">
              {t('SectionHeaderDescription Technology1')}<br/>
              {t('SectionHeaderDescription Technology2')}
              </div>
            </div>
          </div>
          <div className="SectionContents fadeDivide">
            <div id="Introduce_main">
              <div id="Introduce_txt1">KASS</div>
              <div id="Introduce_txt2">
                <span className="Introduce_txt2_blue"> K</span>orea 
                <span className="Introduce_txt2_blue"> A</span>ugmentation 
                <span className="Introduce_txt2_blue"> S</span>atellite 
                <span className="Introduce_txt2_blue"> S</span>ystem
              </div>
              <div id="Introduce_txt3">{t('Introduce_txt3')}</div>
              <div id="Introduce_img">
                <img style={{position:'absolute', left:0, top:0 }} src= {introduceImg1} alt="Introduce Icon"/>
                <img id="Img_earth" style={{position:'absolute', left:400, top:100}} src= {introduceImg2}  alt="Introduce Icon"/>
                <img style={{position:'absolute', left:800, top:200 }} src= {introduceImg3}  alt="Introduce Icon"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="Business">
        <div className="Section">
          <div className="SectionHeaderFull">
            <div className="SectionHeaderTxtbox">
              <div className="SectionHeaderCategory CategoryBright fadeDivide">Business</div>
              <div className="SectionHeaderTitle whiteFonts fadeDivide">{t('SectionHeaderTitle Business1')}</div>
              <div className="SectionHeaderDescription whiteFonts fadeDivide">{t('SectionHeaderDescription Business1')}</div>
            </div>
          </div>
          <div className="SectionContentsGrid">
            <div className="GridContents fadeDivide">
              <img className="BusinessImg" style={{width: 245, height: 184, left: 42, top: -67}} src={businessImg1} alt="Business Icon"/>
              <div className="GridTitle">{t('GridTitle Business1')}</div>
              <div className="GridDesc">{t('GridDesc Business1')}</div>
              <div className="LineBox">
                <div className="Line"></div>
              </div>
              <div className="GridTxt">{t('GridTxt Business1')}</div>
            </div>
            <div className="GridContents fadeDivide">
              <img className="BusinessImg" style={{width: 199, height: 170, left: 83, top: -48}} src={businessImg2} alt="Business Icon"/>
              <div className="GridTitle">{t('GridTitle Business2')}</div>
              <div className="GridDesc">Location Based Service</div>
              <div className="LineBox">
                <div className="Line"></div>
              </div>
              <div className="GridTxt">{t('GridTxt Business2')}</div>
            </div>
            <div className="GridContents fadeDivide">
              <img className="BusinessImg" style={{width: 265, height: 150, left: 48, top: -42}} src={businessImg3} alt="Business Icon"/>
              <div className="GridTitle">{t('GridTitle Business3')}</div>
              <div className="GridDesc">{i18n.language?.startsWith('ko') ? 'ASTRONAV' : 'ASTRONAV'}</div>
              <div className="LineBox">
                <div className="Line"></div>
              </div>
              <div className="GridTxt">{t('GridTxt Business3')}</div>
            </div>
          </div>
        </div>
      </div>

      <div id="Service">
        <div className="Section" style={{gap:'40px'}}>
          <div className="SectionHeaderFull">
            <div className="SectionHeaderTxtbox">
              <div className="SectionHeaderCategory CategoryDark fadeDivide">Service</div>
              <div className="SectionHeaderTitle fadeDivide"><span>{t('SectionHeaderTitle Service1')} </span><span style={{color: '#005E98'}}>{t('SectionHeaderTitle Service2')}</span></div>
              <div className="SectionHeaderDescription fadeDivide">{t('SectionHeaderDescription Service1')}</div>
              <div className="SectionHeaderDescriptionSub fadeDivide">{t('SectionHeaderDescription Service2')}
              <br/>{t('SectionHeaderDescription Service3')}</div>
            </div>
          </div>
          <div className="SectionContentsCard" style={{letterSpacing:'-0.5px'}}>
            <div className="CardContent1 fadeDivide">
              <div className="CardTxtBox">
                <div className="GpsTxt1" style={{color: '#5C5C5C', fontSize: '16px', fontWeight: '500'}}>GPS</div>
                <div className="GpsTxt2" style={{color: '#1B1B1B', fontSize: '18px', fontWeight: '600', lineHeight: '28px'}}>{t('GpsTxt2')}</div>
                <div className="GpsTxt3" style={{color: '#5C5C5C'}}>
                  <span style={{fontSize: '20px', fontWeight: '700', lineHeight: '32px'}}>▶ {t('GpsTxt3-1')}<br/></span>
                  <span style={{fontSize: '16px', fontWeight: '500', lineHeight: '30px'}}>{t('GpsTxt3-2')}<br/>{t('GpsTxt3-3')}<br/>{t('GpsTxt3-4')}<br/>{t('GpsTxt3-5')}</span></div>
                <div className="CardContentImgCenter">
                  <img className="GpsImg1" style={{width: 172, height: 127}} src={serviceImg1} alt="Service Icon" />
                  <div className="GpsImgTxt" style={{textAlign: 'center', color: '#727272', fontSize: '20px', fontWeight: '600', lineHeight: '34px'}}>{t('GpsImgTxt')}</div>
                </div>
              </div>
            </div>
            <div className="CardContent2 fadeDivide">
              <div className="CardTxtBox">
                <div className="KassTxt1" style={{color: '#023859', fontSize: '16px', fontWeight: '500'}}>KASS</div>
                <div className="KassTxt2" style={{fontSize: '26px'}}>
                  <span style={{color: '#1B1B1B', fontWeight: '700'}}>{t('KassTxt2-1')} </span>
                  <span style={{color: '#005E98', fontWeight: '700'}}>{t('KassTxt2-2')}</span>
                </div>
                <div className="KassTxt3" style={{fontSize: '18px'}}>
                  <span style={{color: '#005E98', fontWeight: '700', lineHeight: '32px'}}>{t('KassTxt3-1')}<br/></span>
                  <span style={{color: 'black', fontWeight: '400'}}>{t('KassTxt3-2')}<br/>{t('KassTxt3-3')}<br/></span>
                  <span style={{color: 'black', fontWeight: '700'}}>{t('KassTxt3-4')}</span>
                </div>
                <div className="CardContentImgRight">
                  <img className="KassImg1" style={{width: 453, height: 313}} src={serviceImg2} alt="Service Icon"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="History">
        <div className="Section" style={{gap:'40px'}}>
          <div className="SectionHeaderFull">
            <div className="SectionHeaderTxtbox">
              <div className="SectionHeaderCategory CategoryBright fadeDivide">History</div>
              <div className="SectionHeaderTitle whiteFonts fadeDivide">{t('SectionHeaderTitle History1')}</div>
              <div className="SectionHeaderDescription whiteFonts fadeDivide">{t('SectionHeaderTitle History2')}</div>
            </div>
          </div>
          <div className="ContentSlider fadeDivide">
            <div className="SliderBg"></div>
            <Slider {...settings2} className='subSlider'>
              <div className="slider-content">
                <img className="subSliderImg" src={historyImg1} alt="History"/>
                    <div className="subSliderContents">
                      <div className="subSliderTitle">2021.01</div>
                      <div className="subSliderTxt">{t('subSliderTxt1')}</div>
                    </div>
              </div>
              <div className="slider-content">
                <img className="subSliderImg" src={historyImg2} alt="History"/>
                    <div className="subSliderContents">
                      <div className="subSliderTitle">2021.01</div>
                      <div className="subSliderTxt">{t('subSliderTxt2')}</div>
                    </div>
              </div>
              <div className="slider-content">
                <img className="subSliderImg" src={historyImg3} alt="History"/>
                    <div className="subSliderContents">
                      <div className="subSliderTitle">2021.01</div>
                      <div className="subSliderTxt">{t('subSliderTxt3')}</div>
                    </div>
              </div>
              <div className="slider-content">
                <img className="subSliderImg" src={historyImg4} alt="History"/>
                    <div className="subSliderContents">
                      <div className="subSliderTitle">2023.06</div>
                      <div className="subSliderTxt">{t('subSliderTxt4')}</div>
                    </div>
              </div>
              <div className="slider-content">
                <img className="subSliderImg" src={historyImg5} alt="History"/>
                    <div className="subSliderContents">
                      <div className="subSliderTitle">2023.09</div>
                      <div className="subSliderTxt">{t('subSliderTxt5')}</div>
                    </div>
              </div>
              <div className="slider-content">
                <img className="subSliderImg" src={historyImg6} alt="History"/>
                    <div className="subSliderContents">
                      <div className="subSliderTitle">2024.12</div>
                      <div className="subSliderTxt">{t('subSliderTxt6')}</div>
                    </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>

      <div id="Partners">
        <div className="Section">
          <div className="SectionHeaderFull fadeDivide">
            <div className="SectionHeaderTxtbox">
              <div className="SectionHeaderCategory CategoryDark">Partners</div>
            </div>
          </div>
          <div className="SectionContentsLogo">
            <div className="ContentLogo fadeDivide">
              <img className="PartnersImg" src={partnersImg1} alt="Partners"/>
              <div className="LogoTitle">{t('LogoTitle')}</div>
              <div className="LogoTxt">Korea Aerospace Research Institute</div>
            </div>
            <div className="ContentLogo fadeDivide">
              <img className="PartnersImg" src={partnersImg2} alt="Partners"/>
              <div className="LogoTitle">ESSP</div>
              <div className="LogoTxt">European Satellite Services Provider</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <Footer />
    </>
  );
};